module.exports = __webpack_public_path__ + "img/blue_logo.b2b23912.png";